module.exports = __webpack_public_path__ + "img/canteen.0b27e846.svg";